<template>
  <div class="navBar flex">
    <div class="cube flex" v-for="(item, index) in listBat" :key="index">
      <div class="circle_one flex-box">
        <img :src="item.img" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum" :style="{ color: item.color }">
          <span class="num">{{ item.value }}</span>
          <span class="ys">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndexByName } from "@/util/index";
import { get } from "@/api/index";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [
        {
          name: "渔业总产值",
          img: require("images/granary/nav/qy.png"),
          value: 115.72,
          color: "#FF9000",
          unit: "亿元"
        },
        {
          name: "水产品总产值",
          img: require("images/granary/nav/gd.png"),
          value: 1032333,
          color: "#00FFFF",
          unit: "万元"
        },
        {
          name: "水产品总产量",
          img: require("images/granary/nav/ld.png"),
          value: 922169,
          color: "#E7F802",
          unit: "吨"
        },
        {
          name: "水产养殖面积",
          img: require("images/granary/nav/yy.png"),
          value: 37497.82,
          color: "#00ff73",
          unit: "公顷"
        },
        {
          name: "渔业船舶吨位",
          img: require("images/granary/nav/yy.png"),
          value: 125998,
          color: "#E7F802",
          unit: "吨"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      get("/api/dp/visual/queryList?code=yy_headdata").then(res => {
        if (res.data && !res.data.length > 0) {
          return;
        }

        const data = res.data[0];
        const item = res.item;
        this.listBat.forEach((e, i) => {
          const index = findIndexByName(e.name, item, "name");
          if (index > -1) {
            this.listBat[i]["value"] = data[item[index]["code"]];
            this.listBat[i]["unit"] = item[index]["unit"];
          }
        });
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  background-color rgba(1,22,76 , 0.7)
  border-radius 4px
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
//   background url('~images/index/nav/navBg.png') center no-repeat
//   background-size 100% 100%
//   opacity .9
//   width 18%
  height 100%
  justify-content center

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem
  width 40px
  height 40px
//   background url('~images/granary/nav/nav-bg.png') no-repeat center
//   background-size 100% 100%

  img
    width 30px
    height 30px
    // vertical-align middle
</style>
